// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.5
// source: roboverse_platform_protos/statekeeping/Reported/Streaming.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported";

export interface Streaming {
  availableStreamSources: Streaming_StreamSource[];
  activeJanusStreams: Streaming_JanusStream[];
}

export interface Streaming_StreamSource {
  name: string;
  type: Streaming_StreamSource_SourceType;
  spotServiceName: string;
  nativeResolution: Streaming_StreamSource_Resolution | undefined;
}

export enum Streaming_StreamSource_SourceType {
  UNKNOWN = 0,
  WEBRTC = 1,
  ROS = 2,
  SPOT = 3,
  V4L2 = 4,
  WHIP = 5,
  UNRECOGNIZED = -1,
}

export function streaming_StreamSource_SourceTypeFromJSON(object: any): Streaming_StreamSource_SourceType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return Streaming_StreamSource_SourceType.UNKNOWN;
    case 1:
    case "WEBRTC":
      return Streaming_StreamSource_SourceType.WEBRTC;
    case 2:
    case "ROS":
      return Streaming_StreamSource_SourceType.ROS;
    case 3:
    case "SPOT":
      return Streaming_StreamSource_SourceType.SPOT;
    case 4:
    case "V4L2":
      return Streaming_StreamSource_SourceType.V4L2;
    case 5:
    case "WHIP":
      return Streaming_StreamSource_SourceType.WHIP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Streaming_StreamSource_SourceType.UNRECOGNIZED;
  }
}

export function streaming_StreamSource_SourceTypeToJSON(object: Streaming_StreamSource_SourceType): string {
  switch (object) {
    case Streaming_StreamSource_SourceType.UNKNOWN:
      return "UNKNOWN";
    case Streaming_StreamSource_SourceType.WEBRTC:
      return "WEBRTC";
    case Streaming_StreamSource_SourceType.ROS:
      return "ROS";
    case Streaming_StreamSource_SourceType.SPOT:
      return "SPOT";
    case Streaming_StreamSource_SourceType.V4L2:
      return "V4L2";
    case Streaming_StreamSource_SourceType.WHIP:
      return "WHIP";
    case Streaming_StreamSource_SourceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Streaming_StreamSource_Resolution {
  height: number;
  width: number;
}

export interface Streaming_JanusStream {
  publisherName: string;
  mappedSource: Streaming_StreamSource | undefined;
}

function createBaseStreaming(): Streaming {
  return { availableStreamSources: [], activeJanusStreams: [] };
}

export const Streaming: MessageFns<Streaming> = {
  encode(message: Streaming, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.availableStreamSources) {
      Streaming_StreamSource.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.activeJanusStreams) {
      Streaming_JanusStream.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Streaming {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreaming();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.availableStreamSources.push(Streaming_StreamSource.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.activeJanusStreams.push(Streaming_JanusStream.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Streaming {
    return {
      availableStreamSources: globalThis.Array.isArray(object?.availableStreamSources)
        ? object.availableStreamSources.map((e: any) => Streaming_StreamSource.fromJSON(e))
        : [],
      activeJanusStreams: globalThis.Array.isArray(object?.activeJanusStreams)
        ? object.activeJanusStreams.map((e: any) => Streaming_JanusStream.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Streaming): unknown {
    const obj: any = {};
    if (message.availableStreamSources?.length) {
      obj.availableStreamSources = message.availableStreamSources.map((e) => Streaming_StreamSource.toJSON(e));
    }
    if (message.activeJanusStreams?.length) {
      obj.activeJanusStreams = message.activeJanusStreams.map((e) => Streaming_JanusStream.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Streaming>, I>>(base?: I): Streaming {
    return Streaming.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Streaming>, I>>(object: I): Streaming {
    const message = createBaseStreaming();
    message.availableStreamSources = object.availableStreamSources?.map((e) => Streaming_StreamSource.fromPartial(e)) ||
      [];
    message.activeJanusStreams = object.activeJanusStreams?.map((e) => Streaming_JanusStream.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStreaming_StreamSource(): Streaming_StreamSource {
  return { name: "", type: 0, spotServiceName: "", nativeResolution: undefined };
}

export const Streaming_StreamSource: MessageFns<Streaming_StreamSource> = {
  encode(message: Streaming_StreamSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.spotServiceName !== "") {
      writer.uint32(26).string(message.spotServiceName);
    }
    if (message.nativeResolution !== undefined) {
      Streaming_StreamSource_Resolution.encode(message.nativeResolution, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Streaming_StreamSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreaming_StreamSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.spotServiceName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.nativeResolution = Streaming_StreamSource_Resolution.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Streaming_StreamSource {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      type: isSet(object.type) ? streaming_StreamSource_SourceTypeFromJSON(object.type) : 0,
      spotServiceName: isSet(object.spotServiceName) ? globalThis.String(object.spotServiceName) : "",
      nativeResolution: isSet(object.nativeResolution)
        ? Streaming_StreamSource_Resolution.fromJSON(object.nativeResolution)
        : undefined,
    };
  },

  toJSON(message: Streaming_StreamSource): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.type !== 0) {
      obj.type = streaming_StreamSource_SourceTypeToJSON(message.type);
    }
    if (message.spotServiceName !== "") {
      obj.spotServiceName = message.spotServiceName;
    }
    if (message.nativeResolution !== undefined) {
      obj.nativeResolution = Streaming_StreamSource_Resolution.toJSON(message.nativeResolution);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Streaming_StreamSource>, I>>(base?: I): Streaming_StreamSource {
    return Streaming_StreamSource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Streaming_StreamSource>, I>>(object: I): Streaming_StreamSource {
    const message = createBaseStreaming_StreamSource();
    message.name = object.name ?? "";
    message.type = object.type ?? 0;
    message.spotServiceName = object.spotServiceName ?? "";
    message.nativeResolution = (object.nativeResolution !== undefined && object.nativeResolution !== null)
      ? Streaming_StreamSource_Resolution.fromPartial(object.nativeResolution)
      : undefined;
    return message;
  },
};

function createBaseStreaming_StreamSource_Resolution(): Streaming_StreamSource_Resolution {
  return { height: 0, width: 0 };
}

export const Streaming_StreamSource_Resolution: MessageFns<Streaming_StreamSource_Resolution> = {
  encode(message: Streaming_StreamSource_Resolution, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.height !== 0) {
      writer.uint32(8).int32(message.height);
    }
    if (message.width !== 0) {
      writer.uint32(16).int32(message.width);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Streaming_StreamSource_Resolution {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreaming_StreamSource_Resolution();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.height = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.width = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Streaming_StreamSource_Resolution {
    return {
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
    };
  },

  toJSON(message: Streaming_StreamSource_Resolution): unknown {
    const obj: any = {};
    if (message.height !== 0) {
      obj.height = Math.round(message.height);
    }
    if (message.width !== 0) {
      obj.width = Math.round(message.width);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Streaming_StreamSource_Resolution>, I>>(
    base?: I,
  ): Streaming_StreamSource_Resolution {
    return Streaming_StreamSource_Resolution.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Streaming_StreamSource_Resolution>, I>>(
    object: I,
  ): Streaming_StreamSource_Resolution {
    const message = createBaseStreaming_StreamSource_Resolution();
    message.height = object.height ?? 0;
    message.width = object.width ?? 0;
    return message;
  },
};

function createBaseStreaming_JanusStream(): Streaming_JanusStream {
  return { publisherName: "", mappedSource: undefined };
}

export const Streaming_JanusStream: MessageFns<Streaming_JanusStream> = {
  encode(message: Streaming_JanusStream, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.publisherName !== "") {
      writer.uint32(10).string(message.publisherName);
    }
    if (message.mappedSource !== undefined) {
      Streaming_StreamSource.encode(message.mappedSource, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Streaming_JanusStream {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreaming_JanusStream();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.publisherName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mappedSource = Streaming_StreamSource.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Streaming_JanusStream {
    return {
      publisherName: isSet(object.publisherName) ? globalThis.String(object.publisherName) : "",
      mappedSource: isSet(object.mappedSource) ? Streaming_StreamSource.fromJSON(object.mappedSource) : undefined,
    };
  },

  toJSON(message: Streaming_JanusStream): unknown {
    const obj: any = {};
    if (message.publisherName !== "") {
      obj.publisherName = message.publisherName;
    }
    if (message.mappedSource !== undefined) {
      obj.mappedSource = Streaming_StreamSource.toJSON(message.mappedSource);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Streaming_JanusStream>, I>>(base?: I): Streaming_JanusStream {
    return Streaming_JanusStream.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Streaming_JanusStream>, I>>(object: I): Streaming_JanusStream {
    const message = createBaseStreaming_JanusStream();
    message.publisherName = object.publisherName ?? "";
    message.mappedSource = (object.mappedSource !== undefined && object.mappedSource !== null)
      ? Streaming_StreamSource.fromPartial(object.mappedSource)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
